if (!customElements.get('lmp-example-deck')) {
 customElements.define('lmp-example-deck', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const { signal } = this.controller;
   const track = this.querySelector('[data-example-track]');
   const cards = [...track.children];
   const controls = this.querySelector('[data-example-controls]');
   const previous = controls.querySelector('[data-example-prev]');
   const next = controls.querySelector('[data-example-next]');
   const count = controls.querySelector('[data-example-count]');
   const positions = () => cards.map(card => card.offsetLeft - cards[0].offsetLeft);
   const current = () => positions().reduce((best, position, index, all) => Math.abs(position - track.scrollLeft) < Math.abs(all[best] - track.scrollLeft) ? index : best, 0);
   const update = () => {
    if (!track.clientWidth) return;
    controls.hidden = track.scrollWidth <= track.clientWidth + 2;
    const index = current();
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
    count.textContent = `${atEnd ? cards.length : index + 1} / ${cards.length}`;
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = atEnd;
   };
   const move = direction => {
    const index = Math.max(0, Math.min(cards.length - 1, current() + direction));
    track.scrollTo({left:positions()[index], behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   previous.addEventListener('click', () => move(-1), {signal});
   next.addEventListener('click', () => move(1), {signal});
   track.addEventListener('scroll', update, {signal, passive:true});
   this.closest('.lmp-example-picker').addEventListener('change', () => requestAnimationFrame(update), {signal});
   this.observer = new ResizeObserver(update);
   this.observer.observe(track);
   update();
  }
  disconnectedCallback() {
   this.controller?.abort();
   this.observer?.disconnect();
   this.controller = null;
  }
 });
}
if (!customElements.get('lmp-journey-cart')) {
  customElements.define('lmp-journey-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('[data-bundle-button]')?.removeAttribute('hidden');
      this.addEventListener('submit', async event => {
        const form = event.target.closest('.lmp-journey__form');
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        const data = new FormData(form);
        const variantId = Number(data.get('id'));
        if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
        const items = [{ id: variantId, quantity: 1 }];
        if (event.submitter?.value === 'bundle') {
          const bookId = Number(this.dataset.bookId);
          if (!Number.isSafeInteger(bookId) || bookId <= 0) return;
          items.push({ id: bookId, quantity: 1 });
        }
        this.busy = true;
        const buttons = [...form.querySelectorAll('button')];
        const status = form.querySelector('[role="status"]');
        const cartLink = form.querySelector('.lmp-journey__cart-link');
        buttons.forEach(button => { button.disabled = true; });
        form.setAttribute('aria-busy', 'true');
        status.textContent = this.dataset.busy;
        cartLink.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          await response.json();
          window.location.assign(this.dataset.cartUrl);
        } catch {
          status.textContent = this.dataset.error;
          cartLink.hidden = false;
          buttons.forEach(button => { button.disabled = false; });
          form.removeAttribute('aria-busy');
          this.busy = false;
        }
      }, true);
    }
  });
}
